export default __webpack_public_path__ + "static/shop-interst-tile-338d71d467858b5f9c900c830691447b.webp";